// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"PlataformasTable_spinnerContainer__r3fdH","botonAdd":"PlataformasTable_botonAdd__l6jhd"};